import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "logOpen", true);
        Vue.set(state, "certOpen", false);
    },
    openLog(state) {
        state.logOpen = true;
        state.certOpen = false;
    },
    openCert(state) {
        state.logOpen = false;
        state.certOpen = true;
    }
}
